import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './components/login/login.component';
import { VerifyAccountComponent } from './components/verify-account/verify-account.component';
import { UserCompaniesListComponent } from './components/user-companies-list/user-companies-list.component';
import { LogoutComponent } from './components/logout/logout.component';
import { RedirectBridgeComponent } from './components/redirect-bridge/redirect-bridge.component';
import { AcceptTermsComponent } from './components/accept-terms/accept-terms.component';
import { GraphUserTestComponent } from './components/graph-user-test/graph-user-test.component';
import { AcsEmailTestComponent } from './components/acs-email-test/acs-email-test.component';
import { SocialSignInTestComponent } from './components/social-sign-in-test/social-sign-in-test.component';
import { TestTempComponent } from './components/test-temp/test-temp.component';

import { GeofenceBlockedComponent } from './components/geofence-blocked/geofence-blocked.component';

const routes: Routes = [
  { path: '', component: LoginComponent },
  { path: 'login', component: LoginComponent },
  { path: 'region-unavailable', component: GeofenceBlockedComponent },
  /** MSAL v5 popup redirect bridge — do not put guards / API calls here. */
  { path: 'redirect', component: RedirectBridgeComponent },
  { path: 'accept-terms', component: AcceptTermsComponent },
  //{ path: 'test/graph-user', component: GraphUserTestComponent },
  //{ path: 'test/acs-email', component: AcsEmailTestComponent },
  { path: 'test/social-sign-in', component: SocialSignInTestComponent },
  { path: 'test/temp', component: TestTempComponent },
  { path: 'verify-account', component: VerifyAccountComponent },
  { path: 'select-company', component: UserCompaniesListComponent },
  { path: 'logout', component: LogoutComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
